// Moglee Base — product page extras.
// 1. Remembers which products a visitor has viewed, in their own browser.
// 2. Loads recently viewed and related products through Shopify's section rendering.

(function () {
  var KEY = 'mb:recently-viewed';
  var MAX = 12;

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (error) {
      return [];
    }
  }

  function write(ids) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(ids.slice(0, MAX)));
    } catch (error) {
      /* private browsing or storage full: ignore */
    }
  }

  var recent = document.querySelector('[data-mb-recent]');
  var current = recent ? recent.getAttribute('data-current-id') : '';

  // Record this product, newest first, no duplicates.
  if (current) {
    var ids = read().filter(function (existing) {
      return existing !== current;
    });
    ids.unshift(current);
    write(ids);
  }

  // Recently viewed, excluding the product on screen.
  if (recent) {
    var limit = parseInt(recent.getAttribute('data-limit'), 10) || 4;
    var wanted = read()
      .filter(function (existing) {
        return existing !== current;
      })
      .slice(0, limit);

    if (wanted.length === 0) {
      recent.remove();
    } else {
      var query = wanted
        .map(function (existing) {
          return 'id:' + existing;
        })
        .join(' OR ');

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var url =
        root +
        'search?section_id=' +
        recent.getAttribute('data-section-id') +
        '&type=product&q=' +
        encodeURIComponent(query);

      fetch(url)
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var next = parsed.querySelector('[data-mb-recent]');
          if (next && next.querySelector('.mb-card')) {
            recent.innerHTML = next.innerHTML;
            recent.removeAttribute('hidden');
          } else {
            recent.remove();
          }
        })
        .catch(function () {
          recent.remove();
        });
    }
  }

  // Related products, from Shopify's own recommendations.
  var related = document.querySelector('[data-mb-related]');
  if (related) {
    var endpoint =
      related.getAttribute('data-url') + '&section_id=' + related.getAttribute('data-section-id');

    fetch(endpoint)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var next = parsed.querySelector('[data-mb-related]');
        if (next && next.querySelector('.mb-card')) {
          related.innerHTML = next.innerHTML;
          related.removeAttribute('hidden');
        } else {
          related.remove();
        }
      })
      .catch(function () {
        related.remove();
      });
  }
})();
